import { WorkOrderStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

export const WorkOrderStatus = {
  Draft: {
    value: WorkOrderStatusEnum.Draft,
    description: 'The work order have not started yet',
    sort: 0,
    tone: StatusToneEnum.Draft,
  },
  InProgress: {
    value: WorkOrderStatusEnum.InProgress,
    description: 'The work order has started',
    sort: 1,
    tone: StatusToneEnum.InProgress,
  },
  Complete: {
    value: WorkOrderStatusEnum.Complete,
    description: 'The work order is done.',
    sort: 2,
    tone: StatusToneEnum.Active,
  },
  Cancelled: {
    value: WorkOrderStatusEnum.Cancelled,
    description: 'The work order has been cancelled.',
    sort: 3,
    tone: StatusToneEnum.Cancelled,
  },
  Destructed: {
    value: WorkOrderStatusEnum.Destructed,
    description: 'The production was destructed: its build was reversed, writing off any scrapped components.',
    sort: 4,
    tone: StatusToneEnum.Failure,
  },
}
